// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'reset-css'
import './style/element-variables.scss'
import './style/lexue-common.css'
import 'font-awesome/css/font-awesome.min.css'
import katex from 'katex'
import 'katex/dist/katex.min.css'

import _ from 'lodash'
import Vue from 'vue'
import ElementUI from 'element-ui'
import { abilitiesPlugin } from '@casl/vue'

import App from './App'
import router from './router'
import store from './store'
import { xhrGet, xhrPost, xhrPut, xhrPatch, xhrDelete, xhrFilePost, xhrFilePut, fetchFile, redirectLogin, redirectUnlogin, isLoggedUser } from './util/xhr-apis'
import './util/vue-filters'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(abilitiesPlugin)
Vue.use(katex)
Vue.use(VueQuillEditor)
window.katex = katex

Vue.prototype.$xhrGet = xhrGet
Vue.prototype.$xhrPost = xhrPost
Vue.prototype.$xhrPut = xhrPut
Vue.prototype.$xhrDelete = xhrDelete
Vue.prototype.$xhrPatch = xhrPatch
Vue.prototype.$xhrFilePost = xhrFilePost
Vue.prototype.$xhrFilePut = xhrFilePut
Vue.prototype.$fetchFile = fetchFile
Vue.prototype.$redirectLogin = redirectLogin
Vue.prototype.$redirectUnlogin = redirectUnlogin
Vue.prototype.$isLoggedUser = isLoggedUser

router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    redirectLogin()
    return
  }

  /* not logged in? try to know whoami FIRST */
  let oldToken = store.state.user.token
  if (!isLoggedUser()) {
    xhrGet('/sso/whoami').then(rs => {
      let user = rs.data
      store.commit('user/login', user)
      /* current stored login token not the same as returned token means user login info changed */
      if (user.token !== oldToken) {
        /* prevent vue render and redirect to user default home */
        window.location.href = user.defaultHome
        window.location.reload()
        return
      }
      /* whoami is all next operations' precondition */
      next()
    })
    /* error doing nothing? redirect to a ERROR page? */
  } else {
    /* brower refresh? */
    if (Vue.prototype.$ability.rules.length === 0 && store.state.user.rules && store.state.user.rules.length > 0) {
      Vue.prototype.$ability.update(store.state.user.rules)
    }
    /* if allow brower history back botton */
    if (_.includes(from.meta.preventGoBacks, to.name)) {
      next(false)
      return
    }
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js